export default __webpack_public_path__ + "fc0002f86439ccd19d5f098fb7d74790.png";